import { decodificarToken } from "../../../login/helper";

export const obterCpfDoUsuarioLogado = () => {
    let data = decodificarToken(localStorage.getItem('ifs_auth'));
    return data?.sub;
}

export const obterNomeCacheRequerimentoTO = () => {
    const cpf = obterCpfDoUsuarioLogado();
    return 'requerimentoTO' + cpf;
}